import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Ul } from '#app/old_components/typography/ul.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Ul',
}

const component: componentProps = {
	name: 'Ul',
	shortName: 'Ul',
	fileName: 'ul',
	category: 'typography',
	description: ['An unordered list of items.'],
	features: ['Drop-in replacement for the native <ul> element.'],
	parts: [
		{
			name: 'Ul',
			description: 'An unordered list of items.',
		},
	],
	usage: `<Ul>
	<li>Milk</li>
	<li>
		Cheese
		<Ul>
			<li>Blue cheese</li>
			<li>Feta</li>
		</Ul>
	</li>
</Ul>`,
	styling: `/* ### Typography ### */
@layer components {
	/* Ul */
	.ul {
		@apply ml-space-10 list-disc;
	}
}`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<Usage usage={usage} shortName={shortName} />
			<Ul>
				<li>Milk</li>
				<li>
					Cheese
					<Ul>
						<li>Blue cheese</li>
						<li>Feta</li>
					</Ul>
				</li>
			</Ul>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
